<template>
  <div>
    <b-table striped hover :items="activated_tickets"></b-table>
  </div>
</template>

<script>
import { db } from "../firebase";
import _ from "lodash";

export default {
  data() {
    return {
      tickets: [],
      orders: [],
      activated_tickets: [],
      ticket_type_groups: []
    };
  },
  firebase: {
    tickets: db.ref("tickets"),
    orders: db.ref("orders")
  },
  watch: {
    tickets: function(value) {
      this.ticket_type_groups = _.groupBy(value, "ticket_type_id");

      this.activated_tickets = [];

      _.forEach(this.ticket_type_groups, (group, key) => {
          let activated = _.filter(group, function(t) {
              if (t.nfc_uid) return true
              else return false
          })

          this.activated_tickets.push({
              id: key,
              activated: activated.length,
              total: group.length
          });
      });
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 60px;
}
</style>